import { PREDICTED_CAPITALIZATION_STATUS_LABELS } from '@common/neo.tax';
import { Badge, Typography } from '@ui-components/neo.tax';

import { TABLE_CELL_PLACEHOLDER, PredictedCapitalizationStatus } from '@neo.tax/shared';

interface PredictedCapitalizationStatusBadgeProps {
  status: PredictedCapitalizationStatus | null;
}

export const PredictedCapitalizationStatusBadge = ({
  status,
}: PredictedCapitalizationStatusBadgeProps): React.ReactElement => {
  switch (status) {
    case PredictedCapitalizationStatus.Capitalizable: {
      return (
        <Badge colorVariant="green" dot={false}>
          {PREDICTED_CAPITALIZATION_STATUS_LABELS[PredictedCapitalizationStatus.Capitalizable]}
        </Badge>
      );
    }
    case PredictedCapitalizationStatus.NotCapitalizable: {
      return (
        <Badge colorVariant="red" dot={false}>
          {PREDICTED_CAPITALIZATION_STATUS_LABELS[PredictedCapitalizationStatus.NotCapitalizable]}
        </Badge>
      );
    }
    case PredictedCapitalizationStatus.Uncertain: {
      return (
        <Badge colorVariant="yellow" dot={false}>
          {PREDICTED_CAPITALIZATION_STATUS_LABELS[PredictedCapitalizationStatus.Uncertain]}
        </Badge>
      );
    }

    default:
      return (
        <Typography color="inherit" textOverflow="truncate" fontSize="inherit">
          {TABLE_CELL_PLACEHOLDER}
        </Typography>
      );
  }
};
